import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps__step-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-24" }, " Pre-fill this form using the information already in PandaDoc ", -1 /* HOISTED */)
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "button button--fill",
  type: "submit"
}, " Fetch information and continue ", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "form form--fixed-fields",
      onSubmit: _withModifiers($setup.updateForm, ["prevent"])
    }, [
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.pandadoc_id,
        type: "text",
        "input-id": "pandadoc-id",
        name: "pandadoc-id",
        label: "PandaDoc document ID",
        required: true,
        errors: $setup.form_errors.pandadoc_id || null,
        "onUpdate:value": _cache[0] || (_cache[0] = ( value ) => $setup.form_fields.pandadoc_id = value)
      }, null, 8 /* PROPS */, ["value", "errors"]),
      _hoisted_4
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3)
  ]))
}